(() => {
  angular.module('app').component('newFrontContainer', {
    template: `<embedded-container class="absolute" style="overflow-y: hidden"
      options="ctrl.options" wait-for-ready-message="true" hide-header="true"
      on-message="ctrl.onMessage(type, payload)" ng-if="ctrl.options"
    ></embedded-container>`,
    controller: Controller,
    controllerAs: 'ctrl',
    // path: the tool's path within the project (`count-report`) or, starting
    // with "/", a canonical route of the React host. query: added to the URL.
    // application: { appKey, customerId } of a customer-level app opened by its
    // canonical route. params: navigation state shared with the iframe.
    bindings: { path: '<', query: '<', params: '<', application: '<', onStateChanged: '&' },
  });

  Controller.$inject = ['$sce', '$rootScope', '$scope', 'NativeAppIntegration'];
  function Controller($sce, $rootScope, $scope, integration) {
    const vm = this;
    let application;
    vm.$onInit = () => {
      const hostUrl = integration.baseUrl();
      const url = new URL(hostUrl || window.newAppURL || 'http://localhost:5173', window.location.origin);
      const base = url.pathname.replace(/\/$/, '');
      if (hostUrl) {
        // React host: the canonical route, and the application it embeds so the
        // host shows it without its own navigation.
        if (vm.path.startsWith('/')) {
          url.pathname = base + vm.path;
          application = vm.application;
        } else {
          const customerId = $rootScope.customer.id;
          const projectId = $rootScope.project.id;
          const route = integration.projectRoute(vm.path, customerId, projectId);
          url.pathname = base + route.path;
          application = { appKey: route.appKey, customerId, projectId };
        }
      } else {
        // Former React front, while newAppStandaloneURL is not configured.
        url.pathname = base +
          `/${encodeURIComponent($rootScope.customer.id)}/p/${encodeURIComponent($rootScope.project.id)}/${vm.path}`;
      }
      url.searchParams.set('lang', $rootScope.currentLang);
      url.searchParams.set('theme', $rootScope.darkMode ? 'dark' : 'light');
      Object.entries(vm.query || {}).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
      });
      vm.options = {
        trustSrc: $sce.trustAsResourceUrl(url.toString()),
        targetOrigin: url.origin,
        application,
      };
    };
    vm.$onChanges = changes => {
      if (vm.options && changes.params) {
        $scope.$broadcast('postMessage', { type: 'NAVIGATE', payload: vm.params || {} });
      }
    };
    vm.onMessage = (type, payload) => {
      if (type === 'STATE_CHANGED' && application) vm.onStateChanged({ params: payload });
    };
  }
})();
